import React from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import '../../styles/pages.css'

const tabs = [
  { path: '/deals/all', label: 'All Deals' },
  { path: '/deals/create', label: 'Create Deal' },
  { path: '/deals/quote-requested', label: 'Quote Requested' },
  { path: '/deals/quote-expiring', label: 'Quote Expiring' },
  { path: '/deals/collections', label: 'Collections' },
  { path: '/deals/payments', label: 'Payments' },
  { path: '/deals/part-ex', label: 'Part Ex' },
  { path: '/deals/exceptions', label: 'Exceptions' }
]

function DealsPage() {
  const location = useLocation()

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Deals</h1>
        <p>Manage quotes and deal workflows</p>
      </div>

      <div className="pageTabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname.startsWith(tab.path) ? 'active' : ''}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  )
}

export default DealsPage
